import React from 'react';
import PropTypes from 'prop-types';

const BillingRow = (props) => {

    const {label, children} = props;

    return (
        <div className="row">
            <div className="col s12 m12 l12">
                <label>{label}:
                </label>
            </div>
            <div className="col s12 m12 l12">
                {children}
            </div>
        </div>
    );
};

BillingRow.propTypes = {
    label: PropTypes.string,
    children: PropTypes.node

};
export default BillingRow;



// WEBPACK FOOTER //
// ./src/components/account/BillingRow.js